module.exports = __webpack_public_path__ + "img/logo.ecac2725.png";